import { render, staticRenderFns } from "./DataImportWizard.vue?vue&type=template&id=a90c7416&"
import script from "./DataImportWizard.vue?vue&type=script&lang=ts&"
export * from "./DataImportWizard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports